module.exports = __webpack_public_path__ + "static/Nicholas-Cornwell-ff604df6fc28ac00b371d0faa201c849.jpg";